// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Selectare',
    titleLinkTooltip: 'Salt la pagină',
    collapseCardTooltip: 'Restrângerea cardului',
    expandCardTooltip: 'Extinderea cardului'
  },
  CardList: {
    loadMore: 'Mai multe',
    notFound: 'Nu s-a găsit niciun element.',
    toolbarSelect: 'Selectare',
    viewCards: 'Carduri',
    viewTiles: 'Dale',
    viewList: 'Listă',
    toolbarView: 'Vizualizare'
  },
  ClosingConfirmation: {
    confirm: 'Ieșire',
    cancel: 'Revenire',
    content: 'Sigur doriți să închideți și să părăsiți această pagină? Dacă ați făcut modificări, acestea nu vor fi salvate.'
  },
  Cuttable: {
    showMore: 'Mai multe',
    showLess: 'Mai puține'
  },
  Dialog: {
    cancelButton: 'Anulare'
  },
  DrawerProgress: {
    cancelButton: 'Anulare'
  },
  Dropdown: {
    close: 'Închidere'
  },
  Form: {
    submitButton: 'Salvare',
    applyButton: 'Aplicare',
    cancelButton: 'Anulare'
  },
  FormField: {
    clear: 'Golire',
    remove: 'Ștergere',
    addMore: 'Adăugarea unei adrese suplimentare'
  },
  FormFieldPassword: {
    improvePassword: 'Pentru a îmbunătăți parola:',
    passwordTooShort: 'Creați o parolă mai lungă.',
    lettersLowerCase: 'Utilizați cel puțin o literă mică.',
    lettersUpperCase: 'Utilizați cel puțin o literă mare.',
    numbers1: 'Utilizați cel puțin o cifră.',
    numbers3: 'Utilizați cel puțin trei cifre.',
    specialChar1: 'Utilizați cel puțin un caracter special (de exemplu: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Utilizați cel puțin două caractere speciale (de exemplu: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Utilizați atât litere mari, cât și litere mici.',
    comboLettersAndNumbers: 'Utilizați atât cifre, cât și litere.',
    comboLettersNumbersSpecial: 'Utilizați cifre, litere și caractere speciale.',
    yourPasswordIsStrong: 'Puteți crea o parolă și mai complexă dacă o faceți mai lungă.',
    passwordStrength: 'Parola este: %%strength%%.',
    strengthVeryStrong: 'FOARTE COMPLEXĂ',
    strengthStrong: 'COMPLEXĂ',
    strengthVeryWeak: 'FOARTE SIMPLĂ',
    strengthWeak: 'SIMPLĂ',
    strengthMedium: 'DE COMPLEXITATE MEDIE',
    hidePassword: 'Ascundere parolă',
    showPassword: 'Afișare parolă',
    generateButton: 'Generare',
    copyButtonHint: 'Copiere parolă',
    copySuccessToast: 'Parola a fost copiată',
    generateButtonHint: 'Generarea unei parole complexe'
  },
  InPlaceEdit: {
    editButtonHint: 'Editare valoare',
    okButtonHint: 'Salvare modificări',
    cancelButtonHint: 'Renunțare la modificări'
  },
  InputFile: {
    browseButton: 'Alegeți fișierul...'
  },
  List: {
    totalRows: 'Nr. total de elemente %%totalRows%%',
    selectedRows: 'Ați selectat %%selectedRows%% din %%totalRows%% elemente',
    all: 'Toate',
    allItemsOnPageSelected: 'Toate elementele din pagină sunt selectate',
    allItemsSelected: 'Toate elementele selectate',
    selectAllItems: 'Selectarea tuturor elementelor',
    selectAllItemsOnPage: 'Selectarea tuturor elementelor din pagină',
    deselectAll: 'Deselectare'
  },
  ListEmptyView: {
    filteredTitle: 'Imposibil de găsit elemente care să se potrivească cu filtrul',
    emptyTitle: 'Se pare că nu e nimic pe aici',
    filteredDescription: 'Rafinați interogarea sau eliminați unele criterii din filtru, apoi încercați din nou.'
  },
  ListOperation: {
    cancelButton: 'Anulare'
  },
  Pagination: {
    totalShort: 'din %%total%%',
    itemsPerPage: 'Elem. pe pagină',
    all: 'Toate',
    total: 'Pagina %%current%% din %%total%%'
  },
  ProgressDialog: {
    closeButton: 'Închidere',
    cancelButton: 'Anulare'
  },
  Select: {
    noOptions: 'Nicio opțiune',
    placeholder: 'Selectați...'
  },
  SpotPopup: {
    total: '%%current%% din %%total%%'
  },
  Toaster: {
    closeGroup: 'Închidere grup'
  }
};